// extracted by mini-css-extract-plugin
module.exports = {"percentageChart":"CampaignChart_percentageChart__2lSfM","nameLabel":"CampaignChart_nameLabel__165dr","valueLabel":"CampaignChart_valueLabel__2YD78"};